import Vue from 'vue'
import Router from 'vue-router'
//课程详情
import Index from '../views/Index.vue'
//帮助中心
import HelpCenter from '../views/helpCenter/helpCenter'
//帮助中心详情
import HelpDetail from '../views/helpCenter/helpDetail'
//隐私协议
import Agreement from '../views/setting/agreement'
//政策
import PrivacyPolicy from '../views/setting/privacyPolicy'
//自学课程
import SelfStudyList from '../views/selfStudy/selfStudyList'
//自学课程简介及目录
import SelfStudyIntro from '../views/selfStudy/selfStudyIntro'
//速成课
import SpeedStudyList from '../views/speedStudy/speedStudyList'
//速成课已购课程
import BuyedCourse from '../views/speedStudy/buyedCourse'
//速成课简介及目录
import SpeedStudyIntro from '../views/speedStudy/speedStudyIntro'
//作业区
import homeworkArea from '../views/homewordArea/workArea'
//评论列表
import commentPage from '../views/comment/commentPage'
import test from '../views/test'
Vue.use(Router)

export default new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes: [
    //作业详情
    {
      path: '/workDetail',
      name: 'Index',
      component: Index
    },
    {
      path: '/HelpCenter',
      name: 'HelpCenter',
      component: HelpCenter,
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/HelpDetail',
      name: 'HelpDetail',
      component: HelpDetail,
      meta: {
        keepAlive: false
      }
    },
    //用户协议
    {
      path: '/Agreement',
      name: 'Agreement',
      component: Agreement,
      meta: {
        keepAlive: false
      }
    },
    //隐私政策
    {
      path: '/PrivacyPolicy',
      name: 'PrivacyPolicy',
      component: PrivacyPolicy,
      meta: {
        keepAlive: false
      }
    },
    //自学课程
    {
      path: '/SelfStudyList',
      name: 'SelfStudyList',
      component: SelfStudyList,
      meta: {
        keepAlive: true
      }
    },
    //简介与目录
    {
      path: '/SelfStudyIntro',
      name: 'SelfStudyIntro',
      component: SelfStudyIntro,
      meta: {
        keepAlive: false
      }
    },
    //速成课
    {
      path: '/SpeedStudyList',
      name: 'SpeedStudyList',
      component: SpeedStudyList,
      meta: {
        keepAlive: true
      }
    },
    //速成课已购课程
    {
      path: '/BuyedCourse',
      name: 'BuyedCourse',
      component: BuyedCourse,
      meta: {
        keepAlive: false
      }
    },
    //速成课简介
    {
      path: '/SpeedStudyIntro',
      name: 'SpeedStudyIntro',
      component: SpeedStudyIntro,
      meta: {
        keepAlive: false
      }
    },
    //作业区
    {
      path: '/homeworkArea',
      name: 'homeworkArea',
      component: homeworkArea,
      meta: {
        keepAlive: true
      }
    },
    //作业区
    {
      path: '/',
      name: 'test',
      component: test
    },
    //评论
    {
      path: '/commentPage',
      name: 'commentPage',
      component: () => import("@/views/comment/commentPage.vue"),
      meta: {
        keepAlive: true
      }
    },
    //系统通知
    {
      path: '/sysNoticePage',
      name: 'sysNoticePage',
      component: () => import("@/views/sysNotice/sysNoticePage.vue"),
      meta: {
        keepAlive: true
      }
    },
    //通知详情
    {
      path: '/sysNoticeDetail',
      name: 'sysNoticeDetail',
      component: () => import("@/views/sysNotice/noticeDetail.vue"),
      meta: {
        keepAlive: false
      }
    },
    //作业通知
    {
      path: '/workNotice',
      name: 'workNotice',
      component: () => import("@/views/workNotice/workNotice.vue"),
      meta: {
        keepAlive: true
      }
    },
    //动态详情
    {
      path: '/notesDetail',
      name: 'notesDetail',
      component: () => import("@/views/notesDetail/index.vue"),
      meta: {
        keepAlive: false
      }
    },
    //分享
    {
      path: '/sharePage',
      name: 'sharePage',
      component: () => import("@/views/sharePage/index.vue"),
      meta: {
        keepAlive: false
      }
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return {
        x: 0,
        y: 0
      }
    }

  }
})
